/**
 * Layout component that queries for data
 * with Gatsby's useStaticQuery component
 *
 * See: https://www.gatsbyjs.org/docs/use-static-query/
 */

import React from "react"
import PropTypes from "prop-types"
import { useStaticQuery, graphql } from "gatsby"

import Header from "./header"

import styled from "styled-components"
import "./layout.css"

const BodyContainer = styled.main`
  padding: 10px;
  h1 {
    margin-top: 50px;
  }
`

const FooterContainer = styled.footer`
  margin-top: 50px;
  background: #73261922;
  padding: 20px 30px;
`
const Footer = styled.footer`
  display: flex;
  justify-content: space-around;
  max-width: 800px;
  margin: auto;

  a {
    color: #222;
  }

  @media only screen and (max-width: 700px) {
    flex-direction: column;
  }
`
const InfoContacto = styled.footer`
  min-width: 250px;
  max-width: 300px;
  margin: 10px auto;
`
const DatosTransferencias = styled.footer`
  min-width: 250px;
  max-width: 300px;
  margin: 10px auto;
  p {
    margin: 0;
  }
`
const Layout = ({ children }) => {
  const data = useStaticQuery(graphql`
    query SiteTitleQuery {
      site {
        siteMetadata {
          title
        }
      }
    }
  `)

  return (
    <>
      <Header siteTitle={data.site.siteMetadata.title} />

      <div
        style={{
          margin: `0 auto`,
          maxWidth: 850,
          paddingTop: "30px",
        }}
      >
        <BodyContainer>{children}</BodyContainer>
      </div>
      <FooterContainer>
        <Footer>
          <InfoContacto>
            <h3>Contacto Delivery</h3>
            <p>
              <a href="tel:+56959157833">+569 59157833</a>
            </p>
            <p>
              <a href="mailto:pagobaco@gmail.com"> pagobaco@gmail.com </a>
            </p>

            <a
              href="https://goo.gl/maps/KLVYk6N7swL3qANv6"
              target="_blank"
              rel="noreferrer"
            >
              Nueva de Lyon 113, Providencia, Chile
            </a>
          </InfoContacto>
          <DatosTransferencias>
            <h3>Datos de Transferencias</h3>
            <p>
              Nombre: <strong>BACO</strong>
            </p>
            <p>
              Rut: <strong>76.278.620-6</strong>
            </p>
            <p>
              Banco: <strong>SECURITY</strong>
            </p>
            <p>
              Nº CC: <strong>49703701</strong>
            </p>
            <p>
              Mail: <strong>pagobaco@gmail.com</strong>
            </p>
          </DatosTransferencias>
        </Footer>
      </FooterContainer>
    </>
  )
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
}

export default Layout
